<template>
  <div class="header-con centered default">
    <div class="header-wrapper" @click="goTo('HomePage')">
      <img class="tpbf-logo" :src="require('@/assets/tpbf/TPBF-logo-white.png')" alt="TPBF logo" width="50" height="50"/>
    </div>
    <div class="header-wrapper header-desktop-only">
      <div class="nav-elems">
        <div class="nav-elem">
          <router-link to="/">Home</router-link>
        </div>
        <div class="nav-elem">
          <router-link to="/events">Events</router-link>
        </div>
        <div class="nav-elem">
          <router-link to="/about-us">About</router-link>
        </div>
        <div class="nav-elem">
          <router-link to="/partners">Our Partners</router-link>
        </div>
        <div class="nav-elem">
          <router-link to="/feeds">News</router-link>
        </div>
      </div>
    </div>
    <div class="override-navs" v-if="overrideNavs" v-html="overrideNavs"></div>
    <div class="header-wrapper end" v-else>
      <div class="search-form">
        <form @submit="submitSearch($event)">
          <div class="search-input">
            <i class="material-icons">search</i>
            <input type="text" 
              v-model="searchValue" 
              placeholder="Search"
              enterkeyhint="search"
              @keydown.enter="submitSearch()">
          </div>
          <button type="button" @click="toggleMobileInput(true)"><i class="material-icons">search</i></button>
          <div :class="['form-input-mobile', {'active': showMobileInput}]">
            <div class="search-input">
              <i class="material-icons">search</i>
              <input type="text" 
                v-model="searchValue" 
                placeholder="Search" 
                enterkeyhint="search"
                @keydown.enter="submitSearch()">
              <div @click="toggleMobileInput(false)" class="form-input-mobile-closer">Cancel</div>
            </div>
          </div>
        </form>
      </div>
      <div class="auth-con header-desktop-only" v-if="!isLoggedIn()">
        <span @click="goSignup()" class="auth-link">Join us</span>
        <span class="auth-separator">|</span>
        <span @click="goTo('LoginPage')" class="auth-link">Sign-in</span>
      </div>
      <!-- <a href="/#contact-us" class="contact-elem">Contact</a> -->
      <div class="auth-content" :class="{'enabled': isLoggedIn()}">
        <div class="nav-elems">
          <div class="nav-elem" @click="goTo('LoginPage')" v-if="!isLoggedIn()">
            <span class="material-icons-outlined">person</span>
          </div>
          <div class="nav-elem burger-menu" :class="{'auth': isLoggedIn()}"
            @click="toggleDropdown">
            <span class="material-icons-outlined">menu</span>
          </div>
        </div>
        <div class="dropdown" :class="{ 'active': showDropdown }">
          <div class="dropdown-overlay"></div>
          <div class="dropdown-wrapper">
            <div class="dropdown-header" :class="{'auth': isLoggedIn()}" v-if="isLoggedIn()">
              <div class="user-avatar">{{ avatar(customer?.firstName) }}</div>
              <div class="user-info">
                <span class="user-name">{{ customerFullname }}</span>
                <span class="user-email">{{ customer?.email }}</span>
                <span class="user-membership">{{ membershipDateInfo }}</span>
              </div>
              <div class="close-dropdown">&times;</div>
            </div>
            <div class="dropdown-header" v-else>
              <div class="close-dropdown">&times;</div>
            </div>
            <div class="dropdown-body">
              <router-link to="/">
                <div class="dropdown-li">
                  <span>Home</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </router-link>
              <router-link to="/events">
                <div class="dropdown-li">
                  <span>Events</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </router-link>
              <router-link to="/about-us">
                <div class="dropdown-li">
                  <span>About</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </router-link>
              <router-link to="/partners">
                <div class="dropdown-li">
                  <span>Our Partners</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </router-link>
              <router-link to="/feeds">
                <div class="dropdown-li">
                  <span>News</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </router-link>
              <!-- <div class="dropdown-item" v-if="isLoggedIn()" @click="checkOut">
                <div class="dropdown-li">
                  <span class="material-icons-outlined">shopping_cart</span>
                  <span>Cart:</span>
                  <span class="cart-count">{{ countCart }}</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </div> -->
              <div class="dropdown-item" v-if="isLoggedIn()" @click="goTo('Settings')">
                <div class="dropdown-li">
                  <span class="material-icons-outlined">settings</span>
                  <span>Account Settings</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </div>
              <div class="dropdown-item" v-if="isLoggedIn()" @click="goTo('MyOrderPage')">
                <div class="dropdown-li">
                  <span class="material-icons-outlined">shopping_bag</span>
                  <span>My Bookings</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </div>
              <div class="dropdown-item" @click="logout" v-if="isLoggedIn()">
                <div class="dropdown-li">
                  <span class="material-icons-outlined">logout</span>
                  <span>Log out</span>
                </div>
                <span class="dropdown-nav-icon material-icons">chevron_right</span>
              </div>
              <div class="join-container" v-if="!isLoggedIn()">
                <div class="join-label">Join a walk</div>
                <div class="join-elem">
                  <router-link to="/events" class="button">Book Now</router-link>
                  <button @click="goTo('LoginPage')" class="outlined">Sign-in</button>
                </div>
                <div class="join-label">Become a partner</div>
                <div class="join-elem">
                  <button class="outlined" @click="goSignup()">Join Us</button>
                </div>
              </div>
            </div>
            <div class="dropdown-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utility from "@/presentation/mixins/utility.js";
import { isEmpty } from "lodash";
import moment from "moment-timezone";
export default {
  mixins: [utility],
  props: {
    preventCheckout: {
      type: Boolean,
      default: false,
    },
    overrideNavs: {
      type: String,
      default: "",
    },
    activeNav: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDropdown: false,
      customer: {},
      searchValue: "",
      showMobileInput: false,
    };
  },
  computed: {
    countCart() {
      let carts = this.$store.getters.getCarts.length || 0;
      if (carts > 0) return carts;
      let booking = this.$store.getters.getBooking;
      return !isEmpty(booking) ? 1 : 0;
    },
    customerFullname() {
      if(isEmpty(this.customer)) return;
      let names = [];
      if(this.customer.firstName) names.push(this.customer.firstName);
      if(this.customer.lastName) names.push(this.customer.lastName);
      return names.join(' ');
    },
    membershipDateInfo() {
      if (isEmpty(this.customer)) return "";
      let date = moment(this.customer.registeredDate).format("MMM DD, YYYY");
      return `Active since ${date}`;
    }
  },
  methods: {
    toggleMobileInput(val){
      this.showMobileInput = val == true;
      this.searchValue = "";
    },
    checkOut() {
      if (this.preventCheckout == true) {
        return;
      }
      this.goTo("CheckoutPage");
    },
    goSignup() {
      this.goToWithParams("LoginPage", {
        signup: true,
      });
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      if (!this.showDropdown) return;
      this.customer = this.$store.getters.getCustomer;
    },
    submitSearch(event){
      try {
        if(event) event.preventDefault();
        let params = {
          keyword: this.searchValue
        }
        console.log(params);
      } catch(err) {
        console.log(err);
      } finally{
        this.toggleMobileInput(false);
      }
    }
  },
  created() {
    let self = this;
    this.showDropdown = false;
    window.addEventListener("click", (e) => {
      if (e.target.closest(".dropdown-overlay")) {
        self.showDropdown = false;
        return;
      }
      if (e.target.closest("a")) {
        self.showDropdown = false;
        return;
      }
      if (e.target.closest(".dropdown-item")) {
        self.showDropdown = false;
        return;
      }
      if (e.target.closest(".close-dropdown")) {
        self.showDropdown = false;
        return;
      }
      if (e.target.closest(".dropdown")) {
        self.showDropdown = true;
        return;
      }
      if (!e.target.closest(".auth-content")) {
        self.showDropdown = false;
      }
    });
  },
};
</script>

<style lang="scss">
.search-form {
  max-width: 200px;
  display: flex;
  flex-direction: column;
  position: relative;
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    overflow: hidden;
    background: transparent;
    border: 1px solid transparent;
    height: 45px;
    max-height: 45px;
    width: 45px;
    max-width: 45px;
  }
  .search-input {
    color: $white;
    display: none;
    gap: 0;
    height: inherit;
    font-family: 'HelveticaNeue', sans-serif;
    input {
      background: transparent;
      height: inherit;
      width: 100%;
      color: $white;
      border: none;
      outline: none;
      font-size: 16px;
      letter-spacing: 1px;
      &::placeholder {
        color: $white;
        opacity: 1;
      }
      &:focus {
        &::placeholder {
          opacity: 0.7;
        }
      }
    }
    i, .material-icons, .material-icons-outlined {
      font-size: 1.2em !important;
    }
  }
  button {
    border: none;
    background: transparent;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    color: $white;
    text-decoration: none;
    i, .material-icons, .material-icons-outlined {
      font-size: 2em !important;
    }
  }
  .form-input-mobile {
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: $white;
    &:not(.active){
      display: none;
    }
    &:is(.active){
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      bottom: 0;
      padding-inline: 32px;
      padding-bottom: 24px;
      padding-top: 60px;
    }
    .form-input-mobile-closer {
      cursor: pointer;
      font-weight: bold;
      &:hover {
        opacity: 0.7;
      }
    }
    .search-input {
      display: flex !important;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      color: $secondary-color-80;
      width: 100%;
      position: relative;
      padding-inline: 0 !important;
      i, .material-icons, .material-icons-outlined {
        position: absolute;
        left: 12px;
        pointer-events: none;
      }
      input {
        width: 100%;
        background: $secondary-color-20;
        height: 45px;
        border-radius: 999px;
        color: $secondary-color-80;
        padding-left: 40px;
        padding-right: 16px;
        &::placeholder {
          color: $secondary-color-60 !important;
        }
      }
    }
  }
}
.tpbf-logo {
  min-height: 90px;
  max-height: 90px;
  width: auto;
  object-fit: contain;
}
a {
  text-decoration: none;
}
.contact-elem {
  background: $white;
  border-radius: 24px;
  padding: 4px 16px;
  display: none;
  overflow: hidden;
  color: $banner-color;
  font-weight: 600;
  font-size: 0.8em;
  cursor: pointer;
  text-decoration: none;
  border: 1px solid transparent;
  &:hover {
    background: $banner-color;
    color: $white;
    border-color: $white;
  }
}
.override-navs {
  color: $secondary-color-100;
}
.auth-content {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  .dropdown {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    color: $secondary-color-90;
    z-index: 10;
    width: 100%;
    display: flex;
    pointer-events: none;
    .dropdown-overlay {
      max-height: 0%;
      height: 100%;
      width: 100%;
      flex: 1;
      overflow: hidden;
    }
    .dropdown-wrapper {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      width: 0%;
      max-width: 350px;
      height: 100%;
      display: flex;
      flex-direction: column;
      background: $banner-color;
      color: $white;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      .dropdown-header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        padding-inline: 24px;
        height: 60px;
        gap: 16px;
        border-bottom: 1px solid $primary-color-50;
        position: relative;
        overflow: hidden;
        color: $white;
        &:is(.auth){
          height: 100px !important;
        }
        .user-avatar {
          pointer-events: none;
          min-width: 50px;
          min-height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          color: $banner-color;
          background: $white;
          font-weight: 700;
          font-size: 1.5em;
        }
        .user-info {
          pointer-events: none;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .user-name {
            font-weight: 600;
            color: $white;
          }
          .user-email {
            font-size: 0.8em;
            color: $white;
          }
          .user-membership {
            font-size: 0.8em;
            color: $white;
          }
        }
        & + * {
          margin-top: 30px;
        }
        .close-dropdown {
          cursor: pointer;
          position: absolute;
          top: 20px;
          right: 24px;
          font-size: 2em;
          color: $white;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .dropdown-body {
        display: flex;
        flex-direction: column;
        flex: 3;
        height: calc(100% - 60px);
        overflow: hidden;
        overflow-y: auto;
        .dropdown-item, a:not(.button) {
          padding-inline: 24px;
          padding-block: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          gap: 8px;
          color: $white;
          font-weight: 500;
          &:hover {
            background: $primary-color-30;
          }
          .dropdown-li {
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .dropdown-nav-icon {
            color: $secondary-color-20;
          }
        }
      }
      .dropdown-footer {
        border-top: 1px solid $primary-color-60;
        padding-inline: 24px;
        color: $white;
        height: 100px;
        overflow: hidden;
      }
    }
    &.active {
      pointer-events: inherit !important;
      .dropdown-overlay {
        max-height: 100%;
        background: $primary-color-20;
        filter: blur(2px);
        -webkit-filter: blur(2px);
        -moz-filter: blur(2px);
        -o-filter: blur(2px);
      }
      .dropdown-wrapper {
        flex: 4;
      }
    }
  }
}
.nav-elems {
  display: flex;
  align-items: center;
  gap: 40px;
  .nav-elem {
    color: $white;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    height: 70px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    &:hover {
      opacity: 0.6;
    }
    &.active {
      color: $primary-color-100;
      .nav-label {
        font-weight: bold;
      }
    }
    &.burger-menu {
      height: 100%;
      padding-block: 10px;
      &:is(.auth){
        min-width: 35px;
        max-width: 35px;
        min-height: 35px;
        max-height: 35px;
      }
    }
    & span {
      font-size: 1.8em !important;
    }
    a {
      text-decoration: none;
      color: inherit;
    }
    .nav-label {
      font-size: 0.7em !important;
    }
    .cart-count {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: orange;
      color: $white;
      font-size: 0.6em !important;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
  }
}
.join-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-inline: 24px;
  padding-block: 16px;
  .join-label {
    font-size: 16px;
    text-align: left;
    margin-top: 24px;
  }
  .join-elem {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
    button,
    .button {
      padding: 4px 20px;
      background: $white;
      border-radius: 999px;
      color: $banner-color;
      font-size: 14px;
      border: 1px solid $white;
      outline: none;
      height: 35px;
      display: flex;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      &:is(.outlined){
        background: transparent;
        color: $white;
      }
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
@media(min-width: 672px){
  .search-form {
    form {
      border-color: $white;
      align-items: flex-start;
      justify-content: flex-start;
      height: 40px;
      max-height: 40px;
      width: 100%;
      max-width: 100%;
    }
    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      padding-inline: 10px;
    }
    .form-input-mobile {
      &:is(.active){
        display: none !important;
      }
    }
  }
  .auth-content {
    &:not(.enabled){
      display: none !important;
    }
    .dropdown {
      &.active {
        .dropdown-wrapper {
          flex: 2 !important;
        }
      }
    }
  }
  .contact-elem {
    display: block !important;
  }
}
@media (min-width: 672px) and (max-width: 1024px) {
  .search-form {
    form {
      border-color: transparent !important;
      align-items: center !important;
      justify-content: center !important;
      height: 45px !important;
      max-height: 45px !important;
      width: 45px !important;
      max-width: 45px !important;
    }
    .search-input {
      display: none !important;
    }
    .form-input-mobile {
      &:is(.active){
        display: flex !important;
      }
    }
  }
  .auth-content {
    &:not(.enabled){
      display: flex !important;
    }
  }
}
</style>
